import { useNotificationPreferencesModal } from '@/stores/ui';
import { NotificationPreferencesModal } from './NotificationPreferencesModal';

export function GlobalNotificationPreferencesModal() {
  const { isNotificationPreferencesOpen, hideNotificationPreferencesModal } =
    useNotificationPreferencesModal();

  return (
    <NotificationPreferencesModal
      isOpen={isNotificationPreferencesOpen}
      onClose={hideNotificationPreferencesModal}
    />
  );
}
